import { axiosJsonInstance } from "@/axios.instance";
import FileStore from "@/types/settings/filestores/FileStore";
import { AxiosInstance } from "axios";

class SettingsApi {
	private axios: AxiosInstance;

	constructor() {
		this.axios = axiosJsonInstance;
	}

	public async getFileStores(): Promise<FileStore[]> {
		const { data } = await this.axios.get("/Settings/FileStores");
		return data;
	}

	public async getFileStoreForGroup(groupId: number): Promise<FileStore | null> {
		const { data } = await this.axios.get(`/Settings/FileStores/${groupId}`);
		return data;
	}

	public async upsertFileStore(fileStore: FileStore): Promise<void> {
		await this.axios.post("/Settings/FileStores", fileStore);
	}

	public async deleteFileStore(fileStoreId: number): Promise<void> {
		await this.axios.delete(`/Settings/FileStores/${fileStoreId}`);
	}
}

const settingsApi = new SettingsApi();
export default settingsApi;
